require('../../style/login.less');
import { ajax, messageBox, cacheClass,common } from '../common/common.js';
import { log } from 'util';
if (cacheClass.getCache() && cacheClass.Cookie.get('username'))
  location.href = '/';
$(function() {
  getRegisterTypeList();
  // input获焦失焦样式
  $('.input-box input').each(function() {
    $(this).focus(function() {
      $(this)
        .parent()
        .addClass('focus')
        .removeClass('error');
    });
    $(this).blur(function() {
      $(this)
        .parent()
        .removeClass('focus');
      // 验证是否为空
      if (
        !$(this)
          .val()
          .trim()
      ) {
        $(this)
          .parent()
          .addClass('error');
      }
      // // 验证是否包含特殊字符及空格
      // if (!/^[\u4E00-\u9FA5A-Za-z0-9]+$/.test($(this).val())) {
      //   $(this)
      //     .parent()
      //     .addClass("error")
      //     .find(".error")
      //     .text("文本格式有误");
      // }
    });
  });
  $('.company').blur(function() {
    if(!$(this).val()) {
      $(this)
        .parent()
        .addClass('error')
        .find('.error')
        .text('企业名称不可为空');
      return
    }
    let res = common.checkChineseAndLetters($(this).val())
    if(!res.flag) {
      $(this)
        .parent()
        .addClass('error')
        .find('.error')
        .text('您输入的企业名称不合法');
    }
  })
  // 手机号验证
  $('.tel').blur(function() {
    if (!$(this).val()) {
      $(this)
        .parent()
        .addClass('error')
        .find('.error')
        .text('手机号码不可为空');
      return;
    }
    if (!regTel($(this).val())) {
      $(this)
        .parent()
        .addClass('error')
        .find('.error')
        .text('手机号码格式错误');
    }
  });
  // 密码验证
  $('.password').blur(function() {
    if (!$(this).val()) {
      $(this)
        .parent()
        .addClass('error')
        .find('.error')
        .text('密码不可为空');
      return;
    }
    if (!regPassword($(this).val())) {
      $(this)
        .parent()
        .addClass('error')
        .find('.error')
        .text('密码格式错误');
    }
  });
  // 获取验证码
  $('.getCode').click(function() {
    if ($(this).text() != '获取验证码') return;
    let tel = $('.tel').val();
    if (!regTel(tel)) {
      $('.tel')
        .parent()
        .addClass('error');
      return;
    }
    ajax.request({
      method: 'POST',
      url: '/app/open/getCode',
      data: {
        phone: tel,
        type: 'register'
      },
      successCallback: function(data) {
        var time = 60;
        $('.getCode')
          .text(time + 'S后重新获取')
          .addClass('gray');
        var timerId = setInterval(function() {
          if (time == 1) {
            clearInterval(timerId);
            $('.getCode')
              .text('获取验证码')
              .removeClass('gray');
            return;
          }
          time--;
          $('.getCode').text(time + 'S后重新获取');
        }, 1000);
      }
    });
  });

  // 注册
  $('.register-btn').click(function() {
    if(!$(this).hasClass('useful')) return
    // 验证不为空
    let flag = true;
    $('.input-box input').each(function() {
      if (!$(this).val()) {
        $(this)
          .parent()
          .addClass('error');
        flag = false;
      }
    });
    // 验证手机格式
    if (!regTel($('.tel').val())) {
      flag = false;
    }
    // 验证密码格式
    if (!regPassword($('.password').val())) {
      flag = false;
    }
    if (!flag) return;
    let category = $('.category .checked').attr('data');
    let company = $('.company').val();
    let tel = $('.tel').val();
    let verifyCode = $('.verifyCode').val();
    let password = $('.password').val();
    let inviteCode = location.href.split('inviteCode')[1]
      ? location.href.split('inviteCode')[1].substr(1)
      : '';
    ajax.request({
      method: 'POST',
      url: '/app/open/register',
      data: {
        registerType: category,
        companyName: company,
        phone: tel,
        code: verifyCode,
        password: password,
        from: 'web',
        inviteCode: inviteCode
      },
      successCallback: function(data) {
        messageBox.show('注册成功');
        setTimeout(() => {
          location.href = '../login/index.html';
        }, 1000);
      }
    });
  });
  // 获取注册类型
  function getRegisterTypeList() {
    ajax.request({
      method: 'GET',
      url: '/app/open/regInit',
      params: {},
      successCallback: function(data) {
        let html = '';
        for (let item of data) {
          html += `<span data="${item.code}">${item.value}</span>`;
        }
        $('.category').html(html);
        // 选择类型
        $('.category span')
          .eq(0)
          .addClass('checked');
        $('.category').on('click', 'span', function() {
          $(this)
            .addClass('checked')
            .siblings()
            .removeClass('checked');
        });
      }
    });
  }
  // 验证手机号
  function regTel(tel) {
    let reg = /^1\d{10}$/;
    if (!reg.test(tel)) {
      return false;
    } else {
      return true;
    }
  }
  // 验证密码
  function regPassword(password) {
    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z_]{6,20}$/;
    if (!reg.test(password)) {
      return false;
    } else {
      return true;
    }
  }
  // 注册按钮绑定回车按键
  $(document).keypress(function(e) {
    var eCode = e.keyCode ? e.keyCode : e.which ? e.which : e.charCode;
    if (eCode == 13) {
      $('.register-btn').click();
    }
  });
  // 注册协议勾选事件
  $('#agreement').change(function(){
    if($(this).is(":checked")) {
      $('.register-btn.orange.register').addClass('useful')
    } else {
      $('.register-btn.orange.register').removeClass('useful')
    }
  })
});



// WEBPACK FOOTER //
// ./src/js/register/index.js